import assetPath from '/opt/actions-runner/_work/crate/crate/xinglets/lebenslauf/components/frame/src/assets/apple-touch-icon-precomposed.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')